import { NavController } from '@ionic/angular'
import { Component } from '@angular/core'

@Component({
  selector: 'app-howto',
  templateUrl: './howto.page.html',
  styleUrls: ['./howto.page.scss'],
})
export class HowtoPage {

  constructor(
    private navCtrl: NavController
  ) { }

  gotoHowToGroup() {
    this.navCtrl.navigateForward(`/howto-group`)
  }

  gotoHowToEvent() {
    this.navCtrl.navigateForward(`/howto-event`)
  }

  gotoHowToInvitation() {
    this.navCtrl.navigateForward(`/howto-invitation`)
  }
}
